// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__UOBt9","modal__content":"Modal_modal__content__hQC1M"};